export default {
  /*
    动态验证码
  */
  getuuid () {
    let uuidTime = new Date().getTime()
    if (window.performance && typeof window.performance.now === 'function') {
      uuidTime += performance.now() // use high-precision timer if available
    }
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (uuidTime + Math.random() * 16) % 16 | 0
      uuidTime = Math.floor(uuidTime / 16)
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
    return uuid
  },
  // 安全的深层取值 js新版可选链特性出来前的替代方案 网上找来的 可能还有很多别的方法
  safeGet (o, p, defaultValue = null) {
    return p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : defaultValue, o)
  }
}


// WEBPACK FOOTER //
// ./src/utils/common.js